import React from 'react'
import './About.css'
import Image from '../images/message-about.png'

const About = () => {
   
  return (
    <>
    <div class="about-section">
		<div class="about-container">
			<div class="about-content-section">
				<div class="about-title">
					<h1>About Me</h1>
				</div>
				<div class="about-content">
					<h2>Created by- <span>Sumit Thakur</span></h2>
					<p>This is a react web-page created only as a college project. The web-page is an encoder tool used to encode any given message. This web-page uses its randomly generated key-value pairs to encode your message, that is why everytime you press 'Generate' a new output and a new key-value pair will get generated. </p>
					<div class="about-button">
                        <button type='button'>Linkdin</button>
					</div>
				</div>
		
			</div>
			<div class="about-image-section">
				<img src={Image} alt=""/>
			</div>
		</div>
	</div>
</>
  )
}

export default About



